import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'label text in layout selector image',
    defaultMessage: 'Label',
    id: 'DlE81g',
  },
  packingSlip: {
    description: 'packing slip text in layout selector image',
    defaultMessage: 'Packing slip',
    id: 'tVJ1Dc',
  },
});
